import React, { useEffect, Fragment } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ScrollTopInterface } from './Interfaces/ScrollTopInterface'

export function withRouter<ComponentProps>(
  Component: React.FunctionComponent<ComponentProps>
) {
  function ComponentWithRouterProp(props: ComponentProps) {
    const location = useLocation()
    const navigate = useNavigate()
    const params = useParams()
    return (
      <>
        <Component {...props} router={{ location, navigate, params }} />
      </>
    )
  }

  return ComponentWithRouterProp
}

function ScrollToTop({ router, children, goTopPage }: ScrollTopInterface) {
  useEffect(() => {
    document.body.scroll({ top: 0, left: 0 })
  }, [router?.location?.pathname])

  return (
    <Fragment>
      {children}
      {goTopPage}
    </Fragment>
  )
}

export default withRouter(ScrollToTop)
